<mc-dialog (closeEvent)="close()">
  <div class="trial-expired-dialog">
    <div class="bg-img"></div>
    <mat-icon class="icon" svgIcon="img-expired-trial"></mat-icon>
    <h3 class="title">Your free trial expired!</h3>
    <span class="description">Choose a plan to keep your website accessible and compliant.</span>
    <mc-button class="button" variant="flat" color="primary" [disabled]="loading" (clickEvent)="handleSiteUpgrade()">
      <div class="button-wrapper">
        Choose a plan
        @if (loading) {
          <mc-progress-spinner class="spinner"></mc-progress-spinner>
        }
      </div>
    </mc-button>
  </div>
</mc-dialog>
